import { ApiClient } from '../../Shared/interfaces/ApiClient';
import {
  UpdateArtEventRequest,
  UpdateArtEventResponse,
  DeleteArtEventResponse,
} from '../interfaces/editArtEventInterfaces';
import { ART_EVENT_ENDPOINTS } from '../constants/endpoints';

const { ART_EVENTS_ENDPOINT, DELETE_ART_EVENT_ENDPOINT } = ART_EVENT_ENDPOINTS;

export const updateArtEventStatus = (
  api: ApiClient,
  data: UpdateArtEventRequest
): Promise<UpdateArtEventResponse | null> => {
  return api.put<UpdateArtEventResponse>(
    ART_EVENTS_ENDPOINT,
    data
  );
};

export const deleteArtEvent = (
  api: ApiClient,
  artEventId: string
): Promise<DeleteArtEventResponse | null> => {
  return api.delete<DeleteArtEventResponse>(
    `${DELETE_ART_EVENT_ENDPOINT}/${artEventId}`
  );
};
